import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { ROUTES } from '../../common/constants';
import NotificationList from './pages/NotificationList';

const NotificationWrapper = () => {
  return (
    <Switch>
      <Route exact path={ROUTES?.NOTIFICATION} component={NotificationList} />
    </Switch>
  );
};

export default NotificationWrapper;
